import { BaseClientRouter } from "@shared/mirage/utils/BaseClientRouter";
import { PrePublicPortalWlConstants } from "@shared/prePublicPortalWestLindsay/constants";

export class PrePublicPortalWLRoutingService extends BaseClientRouter {
    public AppName = PrePublicPortalWlConstants.AppName;
    public Root = "/prePublicPortal" as const;
    public Form = "form";
    public ApplicantDetails = "applicantDetails" as const;
    public AgentDetails = "agentDetails" as const;
    public DescriptionOfDevelopment = "descriptionOfDevelopment" as const;
    public TypeOfDevelopment = "typeOfDevelopment" as const;
    public SiteDetails = "siteDetails" as const;
    public Stage = "stage" as const;
    public AdditionalInformation = "additionalInformation" as const;
    public Confirm = "confirm" as const;
    public Payments = "payments" as const;
    public SubmitSuccess = "submitSuccess" as const;
    public SubmitError = "submitError" as const;

    public FormRoute() {
        return this.toRoute(this.Root, this.Form);
    }
    public FormApplicantDetailsRoute() {
        return this.toRoute(this.Root, this.Form, this.ApplicantDetails);
    }
    public FormAgentDetailsRoute() {
        return this.toRoute(this.Root, this.Form, this.AgentDetails);
    }
    public FormDescriptionOfDevelopmentRoute() {
        return this.toRoute(this.Root, this.Form, this.DescriptionOfDevelopment);
    }
    public FormTypeOfDevelopmentRoute() {
        return this.toRoute(this.Root, this.Form, this.TypeOfDevelopment);
    }
    public FormSiteDetailsRoute() {
        return this.toRoute(this.Root, this.Form, this.SiteDetails);
    }
    public FormStageRoute() {
        return this.toRoute(this.Root, this.Form, this.Stage);
    }
    public FormAdditionalInformationRoute() {
        return this.toRoute(this.Root, this.Form, this.AdditionalInformation);
    }
    public FormConfirmRoute() {
        return this.toRoute(this.Root, this.Form, this.Confirm);
    }
    public FormSubmitSuccessRoute() {
        return this.toRoute(this.Root, this.SubmitSuccess);
    }
    public FormSubmitErrorRoute() {
        return this.toRoute(this.Root, this.SubmitError);
    }

    public PrePublicPortalWlFormSteps = {
        APPLICANT_DETAILS: this.ApplicantDetails,
        AGENT_DETAILS: this.AgentDetails,
        DESCRIPTION_OF_DEVELOPMENT: this.DescriptionOfDevelopment,
        TYPE_OF_DEVELOPMENT: this.TypeOfDevelopment,
        SITE_DETAILS: this.SiteDetails,
        STAGE: this.Stage,
        ADDITIONAL_INFORMATION: this.AdditionalInformation,
        CONFIRM: this.Confirm,
        ERROR: "error",
        EXCEPTION: "exception",
    } as const;
}
